import {
  faArrowUpRightFromSquare,
  faPen as faPenRegular,
  faSearch as faSearchRegular,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faCircleInfo as faCircleInfoSolid,
  faPen as faPenSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import { formServiceUrl } from '@libs/serviceUrls';

import { useGNBFoldHandle } from '@app/containers/GlobalNavigationBar/GNBFoldHandleContext';
import GNBLinkButtonIcon from '@app/containers/GlobalNavigationBar/GNBLinkButtonIcon';
import GuideTooltip from '@app/containers/GlobalNavigationBar/GuideTooltip';
import useGNBGuideActive from '@app/hooks/useGNBGuideActive';
import { recordGTMEvent } from '@app/store/analytics/actions';

import GlobalNavigationBarMenu from '../GlobalNavigationBarMenu';
import DraftVideo from '../GuideTooltip/draft.mp4';

export default function DraftSection() {
  const dispatch = useDispatch();
  const isGuideActive = useGNBGuideActive();

  const { folded } = useGNBFoldHandle();

  return (
    <Box as="section">
      {folded || (
        <Text as="div" color="textNeutralUltraLight" fontSize="sm" fontWeight="bold" p={3} pb={1}>
          서식
        </Text>
      )}
      <Flex
        alignItems={folded ? 'center' : 'initial'}
        as="ul"
        flexDirection="column"
        gap={folded ? 4 : 0}
      >
        <GuideTooltip
          name="작성서식"
          title="전문가가 작성한 서식을 그대로 이용하거나 우리 비즈니스에 맞는 계약서로  편집할 수 있어요."
          video={DraftVideo}
        >
          <GlobalNavigationBarMenu
            leftIcon={<GNBLinkButtonIcon icon={faPenRegular} />}
            leftIconActive={<GNBLinkButtonIcon icon={faPenSolid} />}
            rightIcon={isGuideActive && <FontAwesomeIcon icon={faCircleInfoSolid} width="11px" />}
            rightIconHovered={
              isGuideActive && (
                <FontAwesomeIcon color="iconEmphasisBase" icon={faCircleInfoSolid} width="11px" />
              )
            }
            style={{ display: 'flex' }}
            to="/drafts"
            onClick={() => dispatch(recordGTMEvent('appDraftsClick', { clickOn: 'GNB메뉴' }))}
          >
            작성서식
          </GlobalNavigationBarMenu>
        </GuideTooltip>
        <GlobalNavigationBarMenu
          leftIcon={<GNBLinkButtonIcon icon={faSearchRegular} />}
          newTab
          rightIconHovered={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          style={{ display: 'flex' }}
          to={formServiceUrl}
          onClick={() => dispatch(recordGTMEvent('formSearchMenuClick', { clickOn: 'GNB메뉴' }))}
        >
          서식검색
        </GlobalNavigationBarMenu>
      </Flex>
    </Box>
  );
}
